import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { cartMini, fetchCartItems, fetchCartPrices, removeItem, removeItems, selectCartPending, selectPrices, selectProductsInCart, selectQtyPending, updateItemQuantity, useDispatch, useSelector, } from "@jti/store";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { useConfig } from "@jti/ui";
import { ThemeVariantProvider } from "../../../../contexts/CartMiniContext";
import { buildCommerceBaseData } from "../../../../hooks/gtm/trackingHelpers";
import useGtmQuantityChange from "../../../../hooks/gtm/useGtmQuantityChange";
import getCartItemsCount from "../../../../utils/getCartItemsCount";
import { CartMiniContentContainer } from "../CartMiniContentContainer";
export const RootContainer = () => {
    const dispatch = useDispatch();
    const { CART_CHECKOUT_PAGE_URL } = useConfig();
    const cart = useSelector((state) => state.cart);
    const cartId = cart.id;
    const productsInCart = useSelector(selectProductsInCart);
    const prices = useSelector(selectPrices);
    const itemsPending = useSelector(selectCartPending);
    const qtyPending = useSelector(selectQtyPending);
    const { opened } = useSelector((state) => state.cartMini);
    const grandTotal = useSelector((state) => state.cart.prices.data?.grandTotal.value);
    const shipping = useSelector((state) => state.cart.prices.data?.shipping?.value);
    const { is_order_limit_enabled: isLimitEnabled, order_limit_value: maxOrderLimit } = useSelector((state) => state.cart.storeConfig);
    useGtmQuantityChange();
    const [limitMessageStatus, setLimitMessageStatus] = useState(false);
    const [isUserClickedToOpenCart, setIsUserClickedToOpenCart] = useState(false);
    useEffect(() => {
        const element = window.document.querySelector("body");
        if (element) {
            element.classList.toggle("body-locked", opened);
        }
    }, [opened]);
    useEffect(() => {
        if (cartId) {
            dispatch(fetchCartItems(cartId));
        }
    }, [dispatch, cartId]);
    useEffect(() => {
        setLimitMessageStatus((grandTotal || 0) - (shipping || 0) > maxOrderLimit && isLimitEnabled);
    }, [grandTotal]);
    // track mini cart open state
    useEffect(() => {
        if (opened && isUserClickedToOpenCart) {
            const data = buildCommerceBaseData(cart);
            dispatchTrackingEvent(TrackingEvents.TrackingCartOpen, data);
        }
    }, [opened, isUserClickedToOpenCart]);
    // handlers
    const handleQuantityChange = useCallback(async (itemId, quantity) => {
        if (cartId) {
            await dispatch(updateItemQuantity({ cartId, itemId, quantity }));
            dispatch(fetchCartItems(cartId));
            dispatch(fetchCartPrices(cartId));
        }
    }, [dispatch, cartId]);
    const handleRemoveItem = useCallback(async (itemId) => {
        if (cartId) {
            await dispatch(removeItem({ cartId, itemId }));
            dispatch(fetchCartItems(cartId));
        }
    }, [dispatch, cartId]);
    const handleRemoveItems = useCallback(async (itemIds) => {
        if (cartId) {
            await dispatch(removeItems({ cartId, itemIds }));
            dispatch(fetchCartItems(cartId));
        }
    }, [dispatch, cartId]);
    const handleCheckoutClick = useCallback(() => {
        window.location.href = CART_CHECKOUT_PAGE_URL;
    }, []);
    const handleOpen = useCallback(() => {
        dispatch(cartMini.actions.open());
        setIsUserClickedToOpenCart(true);
    }, [dispatch]);
    const handleClose = useCallback(() => {
        dispatch(cartMini.actions.close());
        setIsUserClickedToOpenCart(false);
    }, [dispatch]);
    const subtotal = prices?.subtotal;
    const subtotalPrice = subtotal && { currency: subtotal.currency, value: subtotal.value };
    return (_jsx(ThemeVariantProvider, { children: _jsx(CartMiniContentContainer, { subtotal: subtotalPrice, items: productsInCart, opened: opened, onOpen: handleOpen, onClose: handleClose, warningStatus: limitMessageStatus, isLimitEnabled: isLimitEnabled, itemsCount: getCartItemsCount(productsInCart), itemsPending: itemsPending, qtyPending: qtyPending, onItemQuantityChange: handleQuantityChange, onRemoveItems: handleRemoveItems, onRemoveItemClick: handleRemoveItem, onCheckoutClick: handleCheckoutClick, isOnCartPage: window.location.href.includes(CART_CHECKOUT_PAGE_URL) }) }));
};
//# sourceMappingURL=RootContainer.js.map